import React from 'react';
import Navbar from '../components/Navbar';
import '../App.css';
import './TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <div className="App">
      <Navbar />
      <main className="terms-container">
        <section className="terms-hero">
          <h1>Terms of Use</h1>
          <p className="terms-updated">Last Updated: December 14, 2025</p>
        </section>
        
        <section className="terms-content">
          <div className="terms-section">
            <p>
              Welcome to Aspen Quick Care's website. By using this site, you agree to a few simple guidelines 
              that help keep everything safe and working properly.
            </p>
            <p>
              We ask that you use the website responsibly and avoid anything harmful, illegal, or disruptive. 
              Sometimes our site may link to other websites for convenience — please note we don't control 
              those sites or their content.
            </p>
            <p>
              If you submit information to us through forms or feedback tools, you allow us to use it to help 
              improve our services. We don't claim ownership of what you share, and we will always handle 
              your information with care.
            </p>
            <p>
              The information on our website is meant to be helpful but should not replace medical advice from 
              a licensed provider. For personal medical concerns, please visit one of our clinics or call us 
              directly.
            </p>
            <p>
              We work hard to keep the website accurate and available, but we can't guarantee it will always 
              be perfect or error-free. Aspen Quick Care is not responsible for any issues that arise from 
              using or being unable to use the site.
            </p>
            <p>
              If you have any questions, you can contact us at <a href="mailto:bettercare@aspenquickcare.com" className="email-link">bettercare@aspenquickcare.com</a>.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TermsOfUse;
